(function () {
  const DESKTOP_MIN = 990;

  function isInsideSearch(el) {
    return !!(
      el.closest(".header__search") ||
      el.closest(".header__search-form") ||
      el.closest("details-modal") ||
      el.closest(".search-modal") ||
      el.closest(".search-modal__content") ||
      el.closest("#SearchModal") ||
      el.closest('form[action*="/search"]') ||
      el.closest('input[type="search"]')
    );
  }

  function getHeaderDropdownDetails() {
    // Works across Dawn variants:
    // - header details-disclosure details
    // - header details (with submenu)
    return Array.from(document.querySelectorAll("header details")).filter((d) =>
      d.querySelector(".header__submenu")
    );
  }

  function closeAllHeaderMenus() {
    getHeaderDropdownDetails().forEach((d) => d.removeAttribute("open"));
  }

  function bindHover(details) {
    if (details.dataset.hoverBound === "1") return;
    details.dataset.hoverBound = "1";

    let closeTimer;

    details.addEventListener("mouseenter", (e) => {
      if (window.innerWidth < DESKTOP_MIN) return;
      if (isInsideSearch(e.target)) return;

      clearTimeout(closeTimer);
      details.setAttribute("open", "");
    });

    details.addEventListener("mouseleave", () => {
      if (window.innerWidth < DESKTOP_MIN) return;

      closeTimer = setTimeout(() => {
        details.removeAttribute("open");
      }, 140);
    });
  }

  function enableHoverMenus() {
    if (window.innerWidth < DESKTOP_MIN) return;
    getHeaderDropdownDetails().forEach(bindHover);
  }

  // When mouse goes over search area, close menus so nothing pops open near search
  function handleSearchMouseMove(e) {
    if (window.innerWidth < DESKTOP_MIN) return;
    if (isInsideSearch(e.target)) closeAllHeaderMenus();
  }

  document.addEventListener("DOMContentLoaded", () => {
    enableHoverMenus();
    document.addEventListener("mousemove", handleSearchMouseMove, { passive: true });
  });

  window.addEventListener("resize", enableHoverMenus);

  // Theme editor / dynamic rerenders
  new MutationObserver(enableHoverMenus).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
